// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","contentWrapper":"Gfda240","iconNoSlotAvailable":"G180262"};